var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", "text-xs-center": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c("v-flex", { attrs: { xs4: "", "offset-xs4": "" } }, [
            _c(
              "div",
              { staticClass: "completeRegistration" },
              [
                _c("v-text-field", {
                  attrs: {
                    label: "E-mail",
                    type: "userEmail",
                    name: "email",
                    rules: _vm.emailRules
                  },
                  model: {
                    value: _vm.userEmail,
                    callback: function($$v) {
                      _vm.userEmail = $$v
                    },
                    expression: "userEmail"
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: {
                    label: _vm.$t("temp_password_label"),
                    type: "password",
                    name: "currentPassword",
                    placeholder: "",
                    rules: _vm.PasswordRules
                  },
                  model: {
                    value: _vm.currentPassword,
                    callback: function($$v) {
                      _vm.currentPassword = $$v
                    },
                    expression: "currentPassword"
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: {
                    label: _vm.$t("new_password"),
                    type: "password",
                    name: "newPassword",
                    rules: _vm.PasswordRules,
                    placeholder: ""
                  },
                  model: {
                    value: _vm.newPassword,
                    callback: function($$v) {
                      _vm.newPassword = $$v
                    },
                    expression: "newPassword"
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: {
                    label: _vm.$t("confirm_password"),
                    type: "password",
                    name: "newPassword",
                    rules: _vm.MatchingPasswords,
                    placeholder: ""
                  },
                  model: {
                    value: _vm.newPassword2,
                    callback: function($$v) {
                      _vm.newPassword2 = $$v
                    },
                    expression: "newPassword2"
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: {
                    label: _vm.$t("firstName"),
                    type: "text",
                    name: "userFirstName",
                    placeholder: ""
                  },
                  model: {
                    value: _vm.userFirstName,
                    callback: function($$v) {
                      _vm.userFirstName = $$v
                    },
                    expression: "userFirstName"
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: {
                    label: _vm.$t("lastName"),
                    type: "text",
                    name: "userLastName",
                    placeholder: ""
                  },
                  model: {
                    value: _vm.userLastName,
                    callback: function($$v) {
                      _vm.userLastName = $$v
                    },
                    expression: "userLastName"
                  }
                }),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { type: "submit" },
                    on: { click: _vm.completeRegistration }
                  },
                  [_vm._v(_vm._s(_vm.$t("completeRegistration")))]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm.error
              ? _c("div", { domProps: { textContent: _vm._s(_vm.error) } })
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-763d787c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-763d787c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompleteRegistration.vue
// module id = null
// module chunks = 